import React from "react";
import { KeyboardBackspace } from "@mui/icons-material";
import { useHistory } from "react-router";
import { paginationStateToUrlSearch } from "../../../../common/hooks/useStatefulPagination";

type PageHeaderBackProps = {
  to: string;
  children: React.ReactNode;
};

export const PageHeaderBack: React.FC<PageHeaderBackProps> = ({ to, children }) => {
  const history = useHistory();
  const locationState: { pagination?: any } = history?.location?.state || {};
  let href = to;
  if (locationState.pagination) {
    href = `${href}?${paginationStateToUrlSearch(locationState.pagination)}`;
  }
  return (
    <a className="text-decoration-none neutral-700 text-weight-regular" href={href}>
      <KeyboardBackspace className="font-size-unset mr-xs" />
      {children}
    </a>
  );
};
